<template>
  <div class="container">
    <form class="form-horizontal">
      <div class="page-header text-primary">
        <span class="glyphicon glyphicon-info-sign"></span> 基本信息
      </div>
      <div class="form-group">
        <label class="col-xs-2">状态
          <select class="form-control" v-model="leader.status" name="" id="">
            <option value="0">实习</option>
            <option value="1">正式</option>
            <option value="2">暂停</option>
            <option value="5">退出</option>
            <option value="3">机动</option>
            <option value="4">专职</option>
          </select>
        </label>
        <label class="col-xs-3">
          导游证号
          <input type="text" v-model="leader.tourCard" class="form-control">
        </label>
        <label class="col-xs-2">
          批次
          <input type="text" class="form-control" v-model="leader.batch">
        </label>
        <label  class="col-xs-2">
          分级
          <input type="text" class="form-control" v-model="leader.level">
        </label>
        <label  class="col-xs-2">
          微信号
          <input type="text" class="form-control" v-model="leader.wechat">
        </label>
        <label  class="col-xs-2">
          姓名
          <input type="text" class="form-control" v-model="leader.name">
        </label>
        <label  class="col-xs-2">
          昵称
          <input type="text" class="form-control" v-model="leader.nickName">
        </label>
        <label  class="col-xs-2">
          性别
          <select class="form-control" name="" id="" v-model="leader.sex">
            <option value="男">男</option>
            <option value="女">女</option>
          </select>
        </label>
        <label  class="col-xs-2">
          证件类型
          <select class="form-control" name="" id="" v-model="leader.idCardType">
            <option value="身份证">身份证</option>
            <option value="其他">其他</option>
          </select>
        </label>
        <label  class="col-xs-3">
          证件号
          <input type="text" v-model="leader.idCard" class="form-control">
        </label>
        <label  class="col-xs-2">
          护照
          <input type="text" class="form-control" v-model="leader.passport">
        </label>
        <label  class="col-xs-2">
          手机号
          <input type="text" class="form-control" v-model="leader.mobile">
        </label>
        <label  class="col-xs-3">
          邮箱
          <input type="text" class="form-control" v-model="leader.email">
        </label>
        <label  class="col-xs-5">
        </label>
      </div>
      <div class="form-group">
        <label class="col-xs-12">
        快递地址
        </label>
        <div class="col-xs-2">
          <input type="text" class="form-control" v-model="leader.province" placeholder="省">
        </div>
        <div class="col-xs-2">
          <input type="text" class="form-control" v-model="leader.city" placeholder="市">
        </div>
        <div class="col-xs-2">
          <input type="text" class="form-control" v-model="leader.county" placeholder="区县">
        </div>
        <div class="col-xs-4">
          <input type="text" class="form-control" v-model="leader.address" placeholder="地址">
        </div>
      </div>
      <div class="form-group">
        <label  class="col-xs-2">
          银行
          <input type="text" class="form-control" v-model="leader.bank">
        </label>
        <label  class="col-xs-2">
          开户支行
          <input type="text" class="form-control" v-model="leader.subBank">
        </label>
        <label  class="col-xs-3">
          账号
          <input type="text" class="form-control" v-model="leader.bankNumber">
        </label>
      </div>
      <div class="form-group">
        <label  class="col-xs-2">
          支付宝
          <input type="text" class="form-control" v-model="leader.alipay">
        </label>
      </div>
      <div class="page-header text-primary">
        <span class="glyphicon glyphicon-info-sign"></span>
        领队能力
      </div>
      <div class="form-group">
        <label class="col-xs-1 text-danger control-label-c">
          角色
        </label>
        <div class="col-xs-11">
          <div class="row">
            <template v-for="item in roles" track-by="$index">
              <label class="checkbox-inline">
                <input type="checkbox" v-model="leader.abilities" :value="item"> {{item}}
              </label>
              <br v-if="$index == 5">
            </template>
          </div>
        </div>
        <label class="col-xs-1 text-danger control-label-c">
          标签
        </label>
        <div class="col-xs-11">
          <div class="row">
            <label class="checkbox-inline" v-for="item in tags" track-by="$index">
              <input type="checkbox" v-model="leader.abilities" :value="item"> {{item}}
            </label>
          </div>
        </div>
      </div>
      <div class="page-header text-primary">
        <span class="glyphicon glyphicon-info-sign"></span> 其他
      </div>
      <div class="form-group">
        <label class="col-xs-2">
          生日
          <input class="form-control" type="date" v-model="leader.birthday">
        </label>
        <label class="col-xs-2">
          星座
          <input type="text" class="form-control" :value="leader.birthday | constellation" disabled>
        </label>
        <label class="col-xs-2">
          紧急联系人
          <input type="text" class="form-control" v-model="leader.emergencyContact">
        </label>
        <label class="col-xs-2">
          紧急联系人手机
          <input type="text" class="form-control" v-model="leader.emergencyMobile">
        </label>
        <label class="col-xs-3">
          现工作单位
          <input type="text" class="form-control">
        </label>
        <label class="col-xs-2">
          所属行业
          <input type="text" class="form-control">
        </label>
        <label class="col-xs-2">
          工作职能
          <input type="text" class="form-control">
        </label>
        <label class="col-xs-2">
          学校
          <input type="text" class="form-control">
        </label>
        <label class="col-xs-2">
          专业
          <input type="text" class="form-control">
        </label>
      </div>
      <div class="form-group">
        <label class="col-xs-12">
          备注
          <textarea class="form-control" cols="30" rows="4"></textarea>
        </label>
      </div>
      <div class="form-group">
        <div class="col-xs-12 text-center">
          <button @click="click(submit)($event)" type="button" class="btn btn-primary">提交</button>
        </div>
      </div>
      <div class="page-header text-primary">
        <span class="glyphicon glyphicon-info-sign"></span> 试走记录
        <button class="btn btn-xs btn-primary" type="button" @click="isShowAddTry = true">添加</button>
      </div>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th></th>
            <th>类型</th>
            <th>简称</th>
            <th>日期</th>
            <th>能力值</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="isShowAddTry">
            <td>
            </td>
            <td>
              <select class="form-control" name="" id="" @change="watchCatalog(tryForm)" v-model="tryForm.catalog">
                <option value=""></option>
                <option v-for="cat in categories" :value="cat">{{cat}}</option>
              </select>
            </td>
            <td>
              <select class="form-control" name="" id="" v-model="tryForm.routeId">
                <option value=""></option>
                <option value="" v-for="r in routes[tryForm.catalog]" :value="r.id">{{r.abbreviation}}</option>
              </select>
            </td>
            <td>
              <div class="btn-group btn-group-xs">
                <button class="btn btn-default" type="button" @click="submitTry(tryForm)">提交</button>
                <button class="btn btn-default" type="button" @click="isShowAddTry = false">取消</button>
              </div>
            </td>
          </tr>
          <template v-for="item in leader.try">
            <tr>
              <td>{{$index + 1}}</td>
              <td>{{item.catalog}}</td>
              <td>{{item.abbreviation}}</td>
              <td>{{item.start}}</td>
              <td><span v-if="item.deleted_at" class="glyphicon glyphicon-remove"></span>
              <span v-else class="glyphicon glyphicon-ok"></span>
              </td>
              <td>
                <div class="btn-group btn-group-xs">
                  <button class="btn btn-default" type="button" @click="editTry(item)">修改</button>
                  <button class="btn btn-danger" type="button" @click="removeTry(item)">删除试走</button>
                  <button class="btn btn-warning" type="button" @click="undoTry(item)">删除能力值</button>
                  <button class="btn btn-success" type="button" @click="doTry(item)">增加能力值</button>
                </div>
              </td>
            </tr>
            <tr v-if="item.isShowEdit">
              <td>
              </td>
              <td>
                <select class="form-control" name="" id="" @change="watchCatalog(item.bak)" v-model="item.bak.catalog">
                  <option value=""></option>
                  <option v-for="cat in categories" :value="cat">{{cat}}</option>
                </select>
              </td>
              <td>

                <select class="form-control" name="" id="" v-model="item.bak.routeId">
                  <option value=""></option>
                  <option value="" v-for="r in routes[item.bak.catalog]" :value="r.id">{{r.abbreviation}}</option>
                </select>
              </td>
              <td>
                <div class="btn-group btn-group-xs">
                  <button class="btn btn-default" type="button" @click="submitTry(item.bak)">提交</button>
                  <button class="btn btn-default" type="button" @click="item.isShowEdit = false">取消</button>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </form>
  </div>
</template>



<script>
  import config from '../../libs/config.js'
  import utils from '../../libs/utils'
  import _ from 'lodash'

  let leader = {
    batch: '',
    level: '',
    name: '',
    nickName: '',
    sex: '男',
    email: '',
    mobile: '',
    tourCard: '',
    idCardType: '身份证',
    idCard: '',
    passport: '',
    wechat: '',
    bank: '',
    subBank: '',
    bankNumber: '',
    birthday: '',
    emergencyContact: '',
    emergencyMobile: '',
    province: '',
    city: '',
    county: '',
    address: '',
    status: 0,
    abilities: [],
    try: [],
    alipay: ''
  }

  let routes = {}
  config.categories.forEach((item) => {
    routes[item] = []
  })

  let tryForm = {
    routeId: '',
    catalog: ''
  }

  export default {
    data () {
      return {
        leader,
        roles: config.givers.roles,
        tags: config.givers.tags,
        categories: config.categories,
        routes,
        tryForm,
        isShowAddTry: false
      }
    },
    methods: {
      editTry (item) {
        item.isShowEdit = true
        item.bak = {}
        item.bak = _.cloneDeep(item)
        this.fetchRoutes(item.catalog)
      },
      watchCatalog (item) {
        this.fetchRoutes(item.catalog)
        item.routeId = ''
      },
      fetchRoutes (catalog) {
        if (this.routes[catalog].length) {
          return
        }
        let params = {
          admin: 'yes',
          paginate: 'no',
          catalog
        }
        return this.$http.get(config.apiWe + '/product/route', params)
          .then(({data}) => {
            this.routes[catalog] = data.list
          })
      },
      submitTry (item) {
        let data = {
          leaderId: this.$route.params.id,
          routeId: item.routeId,
          catalog: item.catalog
        }
        let ajax
        if (item.id) {
          ajax = this.$http.put(`${config.api}/giver/try/${item.id}`, data)
        } else {
          ajax = this.$http.post(`${config.api}/giver/try`, data)
        }

        ajax.then(() => {
          this.fetchInfo()
        })
      },
      removeTry (item) {
        if (window.confirm('删除不可恢复,确认删除记录?')) {
          return this.$http.delete(`${config.api}/giver/try/${item.id}`)
            .then(() => {
              this.fetchInfo()
            })
        } else {
          return Promise.resolve()
        }
      },
      undoTry (item) {
        if (window.confirm('确认删除能力值?')) {
          return this.$http.put(`${config.api}/giver/try/${item.id}/undo`)
            .then(() => {
              this.fetchInfo()
            })
        } else {
          return Promise.resolve()
        }
      },
      doTry (item) {
        if (window.confirm('确认增加能力值?')) {
          return this.$http.put(`${config.api}/giver/try/${item.id}/do`)
            .then(() => {
              this.fetchInfo()
            })
        } else {
          return Promise.resolve()
        }
      },
      submit (e) {
        let id = this.$route.params.id
        let method = 'post'
        let url = config.api + '/giver/leader'

        if (id) {
          method = 'put'
          url = url += '/' + id
        }

        let data = this.leader
        return this.$http[method](url, data)
      },
      fetchInfo () {
        if (this.$route.params.id) {
          return this.$http.get(config.api + '/giver/leader/' + this.$route.params.id)
            .then(({data}) => {
              data.try.forEach((item) => {
                item.isShowEdit = false
                item.bak = {}
              })
              this.leader = data
            })
        }
      },
      click: utils.click
    },
    route: {
      data (transition) {
        this.fetchInfo()
      }
    }
  }

</script>

<style scoped>
  /*[class*="col-xs"] {
    padding-left: 5px;
    padding-right: 5px;
  }*/
  .control-label-c {
    padding-top: 7px;
    margin-bottom: 0;
  }
  label {
    cursor: pointer;
    font-weight: normal;
  }
</style>



/** WEBPACK FOOTER **
 ** Item.vue?49d8637b
 **/